//AVAILABLE ICONS: coins, wallet, growing-up, resize,
//                 person, touch, chart-pie, bank-check, id,
//                 store, exit, house, people, link-default,
//                 square-pin, add, picto, question, mail, phone, rounded-close
//                 filter, info, lamp, document, person-checked, link-add, person-add, person-delete, phone-down

import React from "react";
import config from "utils/serverVars";

const FallBackIcon = fill => ({
  path: <path d="M2 50V2H26V50H2Z" stroke={fill} strokeWidth="3" />,
  viewbox: "0 0 28 52"

});
const getIcon = (fill, name) => {
  let icons = [
    {
      name: 'checked',
      path: (
        <>
          <path fill={fill} fillRule="evenodd" clipRule="evenodd" d="M21.4142 6.66672L9.33336 18.7476L2.58582 12L4.00003 10.5858L9.33336 15.9192L20 5.2525L21.4142 6.66672Z" />
        </>
      ),
      viewbox: "0 0 24 24"
    },
    {
      name: 'clock',
      path: (
        <>
          <path fill={fill} d="M13 12.8182V9.18182H11V14.8182H16.5556V12.8182H13Z" />
          <path fill={fill} fillRule="evenodd" clipRule="evenodd" d="M12 4.63635C7.00837 4.63635 3 8.7685 3 13.8182C3 18.8678 7.00837 23 12 23C16.9916 23 21 18.8678 21 13.8182C21 8.7685 16.9916 4.63635 12 4.63635ZM5 13.8182C5 9.83046 8.15507 6.63635 12 6.63635C15.8449 6.63635 19 9.83046 19 13.8182C19 17.8059 15.8449 21 12 21C8.15507 21 5 17.8059 5 13.8182Z" />
        </>
      ),
      viewbox: "0 0 24 24"
    },
    {
      name: 'document-lines',
      path: (
        <>
          <path d="M12 16H6V18H12V16Z" fill={fill} />
          <path d="M6 11H18V13H6V11Z" fill={fill} />
          <path d="M18 6H6V8H18V6Z" fill={fill} />
          <path fillRule="evenodd" clipRule="evenodd" d="M2 1H22V16.4142L15.4142 23H2V1ZM4 3V21H14V15H20V3H4ZM18.5858 17L16 19.5858V17H18.5858Z" fill={fill} />
        </>
      ),
      viewbox: "0 0 24 24"
    },
    {
      name: "link-add",
      path: (
        <>
          <path fillRule="evenodd" clipRule="evenodd" d="M14.8155 1.55106C14.8158 1.55119 14.8162 1.55132 14.5026 2.49211L14.8155 1.55106L15.7649 1.86754L15.1325 3.76491L14.1877 3.44999L14.1747 3.44593C14.161 3.44178 14.1372 3.43473 14.1041 3.4257C14.0377 3.40761 13.9352 3.38184 13.8039 3.35558C13.5393 3.30266 13.1691 3.25 12.75 3.25C11.9041 3.25 10.9534 3.46079 10.2071 4.20711L4.20711 10.2071C3.46079 10.9534 3.25 11.9041 3.25 12.75C3.25 13.1691 3.30266 13.5393 3.35558 13.8039C3.38184 13.9352 3.40761 14.0377 3.4257 14.1041C3.43473 14.1372 3.44178 14.161 3.44593 14.1747L3.44978 14.1871L3.76491 15.1325L1.86754 15.7649L1.55132 14.8162L2.5 14.5C1.55132 14.8162 1.55145 14.8166 1.55132 14.8162L1.55078 14.8146L1.55015 14.8127L1.54862 14.808L1.54453 14.7954C1.54137 14.7855 1.53734 14.7726 1.53258 14.757C1.52307 14.7257 1.51059 14.6832 1.49617 14.6303C1.46739 14.5248 1.43066 14.3773 1.39442 14.1961C1.32234 13.8357 1.25 13.3309 1.25 12.75C1.25 11.5959 1.53921 10.0466 2.79289 8.79289L8.79289 2.79289C10.0466 1.53921 11.5959 1.25 12.75 1.25C13.3309 1.25 13.8357 1.32234 14.1961 1.39442C14.3773 1.43066 14.5248 1.46739 14.6303 1.49617C14.6832 1.51059 14.7257 1.52307 14.757 1.53258C14.7726 1.53734 14.7855 1.54137 14.7954 1.54453L14.808 1.54862L14.8127 1.55015L14.8155 1.55106Z" fill={fill} />
          <path fillRule="evenodd" clipRule="evenodd" d="M20.1324 6.23508L20.4487 7.18377L19.5 7.5C20.4487 7.18377 20.4488 7.18415 20.4489 7.18454L20.4492 7.18539L20.4498 7.1873L20.4514 7.19196L20.4555 7.20462C20.4586 7.21453 20.4626 7.22737 20.4674 7.24301C20.4769 7.27428 20.4894 7.31685 20.5038 7.36969C20.5326 7.47523 20.5693 7.62268 20.6056 7.80388C20.6777 8.16429 20.75 8.66909 20.75 9.25C20.75 10.4041 20.4608 11.9534 19.2071 13.2071L13.2071 19.2071C11.9534 20.4608 10.4041 20.75 9.24999 20.75C8.66908 20.75 8.16428 20.6777 7.80387 20.6056C7.62267 20.5693 7.47523 20.5326 7.36968 20.5038C7.31684 20.4894 7.27428 20.4769 7.24301 20.4674C7.22736 20.4627 7.21452 20.4586 7.20461 20.4555L7.19195 20.4514L7.18729 20.4498L7.18538 20.4492L7.18454 20.4489C7.18414 20.4488 7.18376 20.4487 7.49999 19.5L7.18376 20.4487L6.23508 20.1325L6.86753 18.2351L7.81239 18.55C7.81181 18.5499 7.81191 18.5499 7.8127 18.5501L7.81292 18.5502L7.82533 18.5541C7.83898 18.5582 7.86283 18.5653 7.89592 18.5743C7.96225 18.5924 8.0648 18.6182 8.1961 18.6444C8.46069 18.6973 8.8309 18.75 9.24999 18.75C10.0958 18.75 11.0466 18.5392 11.7929 17.7929L17.7929 11.7929C18.5392 11.0466 18.75 10.0959 18.75 9.25C18.75 8.8309 18.6973 8.4607 18.6444 8.19611C18.6181 8.06481 18.5924 7.96226 18.5743 7.89593C18.5653 7.86283 18.5582 7.83899 18.5541 7.82534L18.5502 7.81293L18.5501 7.8127C18.5499 7.81192 18.5498 7.81181 18.55 7.81239L18.2351 6.86754L20.1324 6.23508Z" fill={fill} />
          <path fillRule="evenodd" clipRule="evenodd" d="M9.41421 14L2 21.4142L0.585785 20L8 12.5858L9.41421 14Z" fill={fill} />
          <path fillRule="evenodd" clipRule="evenodd" d="M21.4142 2L14 9.41421L12.5858 8L20 0.585785L21.4142 2Z" fill={fill} />
          <path fillRule="evenodd" clipRule="evenodd" d="M21 16V24H19V16H21Z" fill={fill} />
          <path fillRule="evenodd" clipRule="evenodd" d="M16 19H24V21H16V19Z" fill={fill} />
        </>
      ),
      viewbox: "0 0 24 24"
    },
    {
      name: "person-checked",
      path: (
        <>
          <path fillRule="evenodd" clipRule="evenodd" d="M7.53724 12.1915C6.33295 12.4131 5.28414 12.7128 4.46503 12.9889C2.95361 13.5002 1.95239 14.9219 1.95239 16.5051V21.0952H12L11.9992 19.0952H3.95239V16.5051C3.95239 15.767 4.41761 15.1165 5.10451 14.884C6.52999 14.4033 8.68392 13.8571 11.0953 13.8571C12.7508 13.8571 14.1438 12.8926 15.081 11.6964C16.0213 10.4963 16.619 8.92632 16.619 7.42857V6.52381C16.619 3.47348 14.1456 1 11.0952 1C8.04489 1 5.57141 3.47348 5.57141 6.52381V7.42857C5.57141 8.92632 6.16913 10.4963 7.10939 11.6964C7.24294 11.8668 7.38574 12.0326 7.53724 12.1915ZM7.57141 6.52381C7.57141 4.57805 9.14946 3 11.0952 3C13.041 3 14.619 4.57805 14.619 6.52381V7.42857C14.619 8.42887 14.2039 9.57313 13.5067 10.4629C12.8066 11.3564 11.9378 11.8571 11.0953 11.8571C10.2527 11.8571 9.38384 11.3564 8.6837 10.4629C7.98657 9.57313 7.57141 8.42887 7.57141 7.42857V6.52381Z" fill={fill} />
          <path d="M16.5239 21.938L22.4619 16L21.0477 14.5858L16.5239 19.1096L14.7144 17.3001L13.3002 18.7143L16.5239 21.938Z" fill={fill} />
        </>
      ),
      viewbox: "0 0 24 24"
    },
    {
      name: 'document',
      path: (
        <path fillRule="evenodd" clipRule="evenodd" d="M22 1H2V23H16.0875L22 16.9531V1ZM4 21V3H20V15.5455H14.6667V21H4ZM16.6667 19.5468L18.6236 17.5455H16.6667V19.5468Z" fill={fill} />
      ),
      viewbox: "0 0 24 24"
    },
    {
      name: 'lamp',
      path: (
        <>
          <path d="M13 4V0H11V4H13Z" fill={fill} />
          <path fillRule="evenodd" clipRule="evenodd" d="M5 12C5 14.7924 6.63505 17.2029 9 18.3264V23H15V18.3264C17.3649 17.2029 19 14.7924 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12ZM13 16.9C15.2822 16.4367 17 14.419 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.419 8.71776 16.4367 11 16.9V21H13V16.9Z" fill={fill} />
          <path d="M6.53555 5.12131L5.12134 6.53552L2.58579 3.91421L4 2.5L6.53555 5.12131Z" fill={fill} />
          <path d="M18.9016 6.53552L17.4873 5.12131L20 2.5L21.4142 3.91421L18.9016 6.53552Z" fill={fill} />
          <path d="M1 11H4V13H1V11Z" fill={fill} />
          <path d="M20 11H23V13H20V11Z" fill={fill} />
        </>
      ),
      viewbox: "0 0 24 24"
    },
    {
      name: 'info',
      path: (
        <>
          <path fillRule="evenodd" clipRule="evenodd" d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z" fill={fill} />
          <path fillRule="evenodd" clipRule="evenodd" d="M13 10.0909V17.5455H11V10.0909H13Z" fill={fill} />
          <path d="M12 8.36364C12.5021 8.36364 12.9091 7.95662 12.9091 7.45455C12.9091 6.95247 12.5021 6.54545 12 6.54545C11.4979 6.54545 11.0909 6.95247 11.0909 7.45455C11.0909 7.95662 11.4979 8.36364 12 8.36364Z" fill={fill} />
        </>
      ),
      viewbox: "0 0 24 24"
    },
    {
      name: 'filter',
      path: (
        <>
          <path fillRule="evenodd" clipRule="evenodd" d="M2 1H22V5.12695L14.8 12.365V19.8071L9.2 22.6219V12.365L2 5.12695V1ZM4 3V4.30162L11.2 11.5397V19.3781L12.8 18.5739V11.5397L20 4.30162V3H4Z" fill={fill} />
        </>
      ),
      viewbox: "0 0 24 24"
    },
    {
      name: 'rounded-close',
      path: (
        <>
          <path fillRule="evenodd" clipRule="evenodd" d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM17.0506 8.36365L13.4142 12L17.0506 15.6364L15.6364 17.0506L12 13.4142L8.36365 17.0506L6.94943 15.6364L10.5858 12L6.94943 8.36365L8.36365 6.94943L12 10.5858L15.6364 6.94943L17.0506 8.36365Z" fill={fill} />
        </>
      ),
      viewbox: "0 0 24 24"
    },
    {
      name: 'message-chat',
      path: (
        <>
          <path fillRule="evenodd" clipRule="evenodd" d="M0 1H24V18H16.4806L12 23.6008L7.51938 18H0V1ZM2 3V16H8.48063L12 20.3992L15.5194 16H22V3H2Z" fill={fill} />
          <path fillRule="evenodd" clipRule="evenodd" d="M6 6H18V8H6V6Z" fill={fill} />
          <path fillRule="evenodd" clipRule="evenodd" d="M6 11H14V13H6V11Z" fill={fill} />
        </>
      ),
      viewbox: "0 0 24 24"
    },
    {
      name: 'question',
      path: (
        <path fillRule="evenodd" clipRule="evenodd" d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 18.3637C12.5021 18.3637 12.9091 17.9566 12.9091 17.4546C12.9091 16.9525 12.5021 16.5455 12 16.5455C11.4979 16.5455 11.0909 16.9525 11.0909 17.4546C11.0909 17.9566 11.4979 18.3637 12 18.3637ZM10.4524 7.9692C11.2069 7.63579 12.0684 7.49423 12.7937 7.56232C13.5435 7.6327 13.9567 7.89896 14.122 8.16657C14.5387 8.84086 14.398 9.81047 13.209 10.818C11.8634 11.9581 11 12.8564 11 14.2727V15.2727H13V14.2727C13 13.8708 13.1202 13.5146 14.5019 12.3438C16.0402 11.0404 16.9977 9.01549 15.8234 7.11523C15.1933 6.09557 14.0443 5.67092 12.9806 5.57107C11.8925 5.46893 10.6895 5.67783 9.64398 6.13987L8.72931 6.54408L9.53773 8.37341L10.4524 7.9692Z" fill={fill} />
      ),
      viewbox: "0 0 24 24"
    },
    {
      name: 'error',
      path: (
        <path d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path>
      ),
      viewbox: "0 0 24 24"
    },
    {
      name: 'phone',
      path: (
        <path fillRule="evenodd" clipRule="evenodd" d="M12.8182 1H13.8182C18.8896 1 23 5.11044 23 10.1818V11.1818H21V10.1818C21 6.21501 17.785 3 13.8182 3H12.8182V1ZM4.72727 1.49487L10.6869 7.45454L7.95967 10.1818L13.8182 16.0403L16.5455 13.3131L22.5051 19.2727L18.7779 23H18.3636C8.77408 23 1 15.2259 1 5.63636V5.22215L4.72727 1.49487ZM3.00534 6.04524C3.21854 14.2054 9.79463 20.7815 17.9548 20.9947L19.6767 19.2727L16.5455 16.1415L13.8182 18.8688L5.13124 10.1818L7.85851 7.45454L4.72727 4.3233L3.00534 6.04524ZM13.8182 4.63635H12.8182V6.63635H13.8182C15.7759 6.63635 17.3636 8.22409 17.3636 10.1818V11.1818H19.3636V10.1818C19.3636 7.11952 16.8805 4.63635 13.8182 4.63635Z" fill={fill} />
      ),
      viewbox: "0 0 24 24"
    },
    {
      name: 'phonebook',
      path: (
        <path fillRule="evenodd" clipRule="evenodd" d="M2 2H16.3333C17.0347 2 17.711 2.27339 18.2124 2.76572C18.7145 3.25866 19 3.93117 19 4.63636V19.3636C19 20.0688 18.7145 20.7413 18.2124 21.2343C17.711 21.7266 17.0347 22 16.3333 22H2V2ZM4 4V20H16.3333C16.516 20 16.6876 19.9286 16.8113 19.8072C16.9343 19.6863 17 19.5264 17 19.3636V4.63636C17 4.47357 16.9343 4.31366 16.8113 4.19284C16.6876 4.07142 16.516 4 16.3333 4H4ZM10 9.6C10 9.20685 10.2837 9 10.5 9C10.7163 9 11 9.20685 11 9.6V10.4C11 10.7931 10.7163 11 10.5 11C10.2837 11 10 10.7931 10 10.4V9.6ZM10.5 7C9.05947 7 8 8.22583 8 9.6V10.4C8 10.839 8.10811 11.2628 8.30222 11.6364L7.18349 12.314L7.1826 12.3146C6.84449 12.5187 6.54854 12.7962 6.33549 13.1389C6.12095 13.484 6 13.881 6 14.2963V16H15V14.2963C15 13.881 14.879 13.484 14.6645 13.1389C14.4515 12.7962 14.1556 12.5187 13.8175 12.3146L13.8165 12.314L12.6978 11.6364C12.8919 11.2628 13 10.839 13 10.4V9.6C13 8.22583 11.9405 7 10.5 7ZM11.0035 12.9484C10.842 12.9822 10.6738 13 10.5 13C10.3262 13 10.158 12.9822 9.99649 12.9484L8.2604 14H12.7396L11.0035 12.9484ZM22.0001 10.5455V5.27274H20.0001V10.5455H22.0001Z" fill={fill}/>
      ),
      viewbox: '0 0 24 24'
    },
    {
      name: 'arrow-go',
      path: (
        <>
          <path d="M22.4142 12L16 5.58578L14.5858 7L18.5858 11L2 11V13L18.5858 13L14.5858 17L16 18.4142L22.4142 12Z" fill={fill} />
        </>
      ),
      viewbox: "0 0 24 24"
    },
    {
      name: 'mail',
      path: (
        <path fillRule="evenodd" clipRule="evenodd" d="M4.00001 3C3.26329 3 2.55676 3.29266 2.03582 3.81359C1.51489 4.33453 1.22223 5.04107 1.22223 5.77778V9.03808L12 14.9169L22.7778 9.03808V5.77778C22.7778 5.04106 22.4851 4.33453 21.9642 3.81359C21.4433 3.29266 20.7367 3 20 3H4.00001ZM3.45003 5.22781C3.5959 5.08194 3.79373 5 4.00001 5H20C20.2063 5 20.4041 5.08194 20.55 5.22781C20.6958 5.37367 20.7778 5.5715 20.7778 5.77778V7.85081L12 12.6387L3.22223 7.85081V5.77778C3.22223 5.5715 3.30417 5.37367 3.45003 5.22781ZM3.22223 18.2222V11.8889H1.22223V18.2222C1.22223 18.959 1.51489 19.6655 2.03582 20.1864C2.55676 20.7074 3.26329 21 4.00001 21H20C20.7367 21 21.4433 20.7074 21.9642 20.1864C22.4851 19.6655 22.7778 18.959 22.7778 18.2222V11.8889H20.7778V18.2222C20.7778 18.4285 20.6958 18.6264 20.55 18.7722C20.4041 18.9181 20.2063 19 20 19H4.00001C3.79373 19 3.5959 18.9181 3.45003 18.7722C3.30417 18.6264 3.22223 18.4285 3.22223 18.2222Z" fill={fill} />
      ),
      viewbox: "0 0 24 24"
    },
    {
      name: 'reload',
      path: (
        <>
          <path d="M19.6885 1.14342L18.721 8.27843L11.498 7.31536L11.7624 5.33291L15.7976 5.87093C14.3978 4.26203 12.3175 3.26213 10.0001 3.26213C5.74653 3.26213 2.26221 6.74645 2.26221 11H0.262207C0.262207 5.64188 4.64196 1.26213 10.0001 1.26213C12.8573 1.26213 15.4476 2.47859 17.2204 4.46053L17.7066 0.874695L19.6885 1.14342Z"
            fill={fill}
          />,
          <path d="M17.7379 11C17.7379 15.2535 14.2536 18.7378 10.0001 18.7378C7.68263 18.7378 5.60232 17.7379 4.20255 16.129L8.23781 16.6671L8.50214 14.6846L1.27916 13.7215L0.311707 20.8565L2.29357 21.1253L2.77978 17.5395C4.55256 19.5214 7.14285 20.7378 10.0001 20.7378C15.3582 20.7378 19.7379 16.3581 19.7379 11H17.7379Z"
            fill={fill}
          />
        </>
      ),

      viewBox: "0 0 20 22"
    },

    {
      name: "picto",
      path: (
        <rect width="100%" height="100%" fill={fill} />
      ),
      viewbox: "0 0 6 6"
    },
    {
      name: "add",
      path: (
        <path fillRule="evenodd" clipRule="evenodd" d="M13 11V4H11V11H4V13H11V20H13V13H20V11H13Z" fill={fill} />
      ),
      viewbox: "0 0 24 24"
    },
    {
      name: "coins",
      path: (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.31015 0.984252C1.11805 1.5803 0 2.58874 0 4V16C0 17.4113 1.1179 18.4197 2.31004 19.0158C3.56193 19.6417 5.22145 20 7 20C8.0647 20 9.08498 19.8716 10 19.6353V20C10 21.4113 11.1179 22.4197 12.31 23.0158C13.5619 23.6417 15.2214 24 17 24C18.7786 24 20.4381 23.6417 21.69 23.0158C22.8821 22.4197 24 21.4113 24 20V12C24 10.5887 22.8819 9.5803 21.6899 8.98425C20.438 8.3583 18.7784 8 17 8C15.9267 8 14.8968 8.1305 13.9736 8.37156C13.9909 8.25098 14 8.12712 14 8V4C14 2.58874 12.8819 1.5803 11.6899 0.984252C10.4379 0.3583 8.77844 0 7 0C5.22156 0 3.56205 0.3583 2.31015 0.984252ZM3.20457 2.77311C2.22509 3.26285 2 3.7544 2 4C2 4.2456 2.22509 4.73715 3.20457 5.22689C4.12424 5.68673 5.46473 6 7 6C8.53527 6 9.87576 5.68673 10.7954 5.22689C11.7749 4.73715 12 4.2456 12 4C12 3.7544 11.7749 3.26285 10.7954 2.77311C9.87576 2.31327 8.53527 2 7 2C5.46473 2 4.12424 2.31327 3.20457 2.77311ZM10.0264 11.6285C9.10326 11.8695 8.07331 12 7 12C5.22145 12 3.56193 11.6417 2.31004 11.0158C2.20589 10.9637 2.10232 10.9085 2 10.8502V12C2 12.2457 2.2251 12.7373 3.20446 13.2269C4.12407 13.6868 5.46455 14 7 14C8.13492 14 9.16586 13.828 10 13.5508V12C10 11.8729 10.0091 11.7491 10.0264 11.6285ZM12 14.85V16C12 16.2457 12.2251 16.7373 13.2045 17.2269C14.1241 17.6868 15.4646 18 17 18C18.5354 18 19.8759 17.6868 20.7955 17.2269C21.7749 16.7373 22 16.2457 22 16V14.85C21.8976 14.9084 21.794 14.9637 21.6899 15.0157C20.438 15.6417 18.7784 16 17 16C15.2216 16 13.5621 15.6417 12.3101 15.0157C12.206 14.9637 12.1024 14.9084 12 14.85ZM22 12C22 12.2456 21.7749 12.7372 20.7954 13.2269C19.8758 13.6867 18.5353 14 17 14C15.4647 14 14.1242 13.6867 13.2046 13.2269C12.2251 12.7372 12 12.2456 12 12C12 11.7544 12.2251 11.2628 13.2046 10.7731C14.1242 10.3133 15.4647 10 17 10C18.5353 10 19.8758 10.3133 20.7954 10.7731C21.7749 11.2628 22 11.7544 22 12ZM10 15.6345V17.5518C9.16662 17.8286 8.13529 18 7 18C5.46455 18 4.12407 17.6868 3.20446 17.2269C2.2251 16.7373 2 16.2457 2 16V14.8502C2.10232 14.9085 2.20589 14.9637 2.31004 15.0158C3.56193 15.6417 5.22145 16 7 16C8.06523 16 9.0852 15.8711 10 15.6345ZM12 20V18.8502C12.1023 18.9085 12.2059 18.9637 12.31 19.0158C13.5619 19.6417 15.2214 20 17 20C18.7786 20 20.4381 19.6417 21.69 19.0158C21.7941 18.9637 21.8977 18.9085 22 18.8502V20C22 20.2457 21.7749 20.7373 20.7955 21.2269C19.8759 21.6868 18.5354 22 17 22C15.4646 22 14.1241 21.6868 13.2045 21.2269C12.2251 20.7373 12 20.2457 12 20ZM12 8V6.85004C11.8976 6.90842 11.794 6.96366 11.6899 7.01575C10.4379 7.6417 8.77844 8 7 8C5.22156 8 3.56205 7.6417 2.31015 7.01575C2.20597 6.96366 2.10235 6.90842 2 6.85004V8C2 8.24573 2.2251 8.73726 3.20446 9.22695C4.12407 9.68675 5.46455 10 7 10C8.53545 10 9.87593 9.68675 10.7955 9.22695C11.7749 8.73726 12 8.24573 12 8Z"
          fill={fill}
        />
      ),
      viewbox: "0 0 24 24"
    },
    {
      name: "wallet",
      path: (
        <>
          {" "}
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 5C0 3.34272 1.34272 2 3 2H7V4H3C2.44728 4 2 4.44728 2 5C2 5.55272 2.44728 6 3 6H4V8H3C1.34272 8 0 6.65728 0 5Z"
            fill={fill}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 0H21V8H19V2H7V8H5V0Z"
            fill={fill}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 5C2 5.55272 2.44728 6 3 6H24V24H4C1.79072 24 0 22.2093 0 20V5H2ZM3 8C2.64934 8 2.31276 7.93989 2 7.8294V20C2 21.1047 2.89528 22 4 22H22V8H3Z"
            fill={fill}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17 14C16.4477 14 16 14.4477 16 15C16 15.5523 16.4477 16 17 16C17.5523 16 18 15.5523 18 15C18 14.4477 17.5523 14 17 14ZM14 15C14 13.3431 15.3431 12 17 12C18.6569 12 20 13.3431 20 15C20 16.6569 18.6569 18 17 18C15.3431 18 14 16.6569 14 15Z"
            fill={fill}
          />
        </>
      ),
      viewbox: "0 0 24 24"
    },
    {
      name: "growing-up",
      path: (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22 0H13V2H18.7547L11.9618 9.54761L6.00001 3.58581L0.292908 9.29291L1.70712 10.7071L6.00001 6.41423L12.0382 12.4524L20 3.60599V9H22V0Z"
          fill={fill}
        />
      ),
      viewbox: "0 0 22 13"
    },
    {
      name: "resize",
      path: (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.81818 0H0V18H18V10.1818H16V16H2V2H7.81818V0ZM10.1818 0H18V7.81818H16V3.41424L9.70712 9.70712L8.29291 8.29291L14.5858 2H10.1818V0Z"
          fill={fill}
        />
      ),
      viewbox: "0 0 18 18"
    },
    {
      name: "person",
      path: (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.90906 5.09091C5.90906 3.38419 7.29325 2 8.99997 2C10.7067 2 12.0909 3.38419 12.0909 5.09091C12.0909 5.97168 11.7242 6.98608 11.1054 7.77582C10.4836 8.56941 9.72294 9 8.99997 9C8.27699 9 7.51634 8.56941 6.89454 7.77582C6.27576 6.98608 5.90906 5.97168 5.90906 5.09091ZM8.99997 0C6.18868 0 3.90906 2.27962 3.90906 5.09091C3.90906 6.46913 4.45831 7.90929 5.32023 9.00934C6.17914 10.1055 7.46394 11 8.99997 11C10.536 11 11.8208 10.1055 12.6797 9.00934C13.5416 7.90929 14.0909 6.46913 14.0909 5.09091C14.0909 2.27962 11.8113 0 8.99997 0ZM6.54544 11.4546C3.2817 11.4546 0.636353 14.0999 0.636353 17.3637V18.9118L1.33158 19.1343L1.63635 18.1818C1.33158 19.1343 1.33244 19.1345 1.33271 19.1346L1.33408 19.1351L1.33752 19.1361L1.34723 19.1392L1.3779 19.1485C1.40334 19.1562 1.43876 19.1666 1.48409 19.1794C1.57473 19.205 1.70498 19.24 1.87423 19.2812C2.21274 19.3637 2.70724 19.4711 3.35286 19.5776C4.64427 19.7906 6.53963 20 8.99999 20C11.4603 20 13.3557 19.7906 14.6471 19.5776C15.2927 19.4711 15.7872 19.3637 16.1257 19.2812C16.295 19.24 16.4252 19.205 16.5159 19.1794C16.5612 19.1666 16.5966 19.1562 16.6221 19.1485L16.6528 19.1392L16.6625 19.1361L16.6659 19.1351L16.6684 19.1343L17.3636 18.9118V17.3637C17.3636 14.0999 14.7183 11.4546 11.4545 11.4546H6.54544ZM16.3636 18.1818C16.6684 19.1343 16.6687 19.1342 16.6684 19.1343L16.3636 18.1818ZM3.67836 17.6043C3.25457 17.5344 2.90666 17.4649 2.63635 17.4051V17.3637C2.63635 15.2045 4.38627 13.4546 6.54544 13.4546H11.4545C13.6137 13.4546 15.3636 15.2045 15.3636 17.3637V17.4051C15.0933 17.4649 14.7454 17.5344 14.3216 17.6043C13.1329 17.8003 11.3464 18 8.99999 18C6.65353 18 4.86708 17.8003 3.67836 17.6043Z"
          fill={fill}
        />
      ),
      viewbox: "0 0 18 20"
    },
    {
      name: "touch",
      path: (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.00317 0.918783C5.34712 0.64938 3.90657 1.92689 3.90657 3.54073V9.17119H3.24895C1.78119 9.17119 0.591339 10.361 0.591339 11.8288V14.2285C0.591339 15.5848 1.05294 16.9007 1.90022 17.9598L4.42595 21.1169H16.539L17.9591 11.886C18.2463 10.0194 16.995 8.2635 15.1369 7.92567L9.2218 6.85019V3.62941C9.2218 2.38837 8.37254 1.14157 7.00317 0.918783ZM5.90657 3.54073C5.90657 3.14099 6.26104 2.82436 6.68202 2.89283C6.94262 2.93524 7.2218 3.21905 7.2218 3.62941V8.51935L14.7791 9.89341C15.5713 10.0374 16.1048 10.7861 15.9824 11.5819L14.8232 19.1169H5.38719L3.46195 16.7104C2.89838 16.0059 2.59134 15.1306 2.59134 14.2285V11.8288C2.59134 11.4656 2.88576 11.1712 3.24895 11.1712H3.90656V13.6576H5.90656V11.1712H5.90657V3.54073Z"
          fill={fill}
        />
      ),
      viewbox: "0 0 18 22"
    },
    {
      name: "chart-pie",
      path: (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.16667 1.70781C4.95556 2.12592 1.66667 5.67888 1.66667 10C1.66667 11.886 2.29319 13.6256 3.34945 15.0222L9.16667 9.63589V1.70781ZM4.48207 16.2449C5.95182 17.5445 7.88379 18.3333 10 18.3333C14.3211 18.3333 17.8741 15.0444 18.2922 10.8333H10.3265L4.48207 16.2449ZM18.2922 9.16667C17.9013 5.22965 14.7703 2.0987 10.8333 1.70781V9.16667H18.2922ZM10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0Z"
          fill={fill}
        />
      ),
      viewbox: "0 0 20 20"
    },
    {
      name: "bank-check",
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 2.91667C0 1.3056 1.3056 0 2.91667 0H13.75V1.66667C13.0594 1.66667 12.5 2.22607 12.5 2.91667V5H0V2.91667ZM11.1139 1.66667H2.91667C2.22607 1.66667 1.66667 2.22607 1.66667 2.91667V3.33333H10.8333V2.91667C10.8333 2.46931 10.934 2.0455 11.1139 1.66667Z"
            fill={fill}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 2.91667C15 2.22607 14.4406 1.66667 13.75 1.66667V0C15.3611 0 16.6667 1.3056 16.6667 2.91667V12.5H15V2.91667Z"
            fill={fill}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.33333 12.5V4.16667H5V12.5H3.33333Z"
            fill={fill}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 11.6667H20V20H0V11.6667ZM1.66667 13.3333V18.3333H18.3333V13.3333H1.66667Z"
            fill={fill}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.33333 15H5.83333V16.6667H3.33333V15Z"
            fill={fill}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.5 15H16.6667V16.6667H7.5V15Z"
            fill={fill}
          />
        </>
      ),
      viewbox: "0 0 20 20"
    },
    {
      name: "id",
      path: (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.16667 2.5C9.16667 2.0394 9.5394 1.66667 10 1.66667C10.4606 1.66667 10.8333 2.0394 10.8333 2.5V4.16667V5.83333H9.16667L9.16667 4.16667L9.16667 2.5ZM7.5 4.16667V2.5C7.5 1.11893 8.61893 0 10 0C11.3811 0 12.5 1.11893 12.5 2.5V4.16667H20V20H0V4.16667H7.5ZM7.5 5.83333H1.66667V18.3333H18.3333V5.83333H12.5V7.5H7.5V5.83333ZM11.6667 10H16.6667V11.6667H11.6667V10ZM16.6667 13.3333H11.6667V15H16.6667V13.3333ZM5.83333 14.1667C5.21633 14.1667 4.67772 14.5018 4.38958 15H8.94375C8.65561 14.5018 8.11701 14.1667 7.5 14.1667H5.83333ZM9.85777 15C9.51462 14.029 8.58863 13.3333 7.5 13.3333H5.83333C4.7447 13.3333 3.81871 14.029 3.47556 15C3.38345 15.2606 3.33333 15.5411 3.33333 15.8333H10C10 15.5411 9.94988 15.2606 9.85777 15ZM7.5 10.8333C7.5 11.2936 7.1269 11.6667 6.66667 11.6667C6.20643 11.6667 5.83333 11.2936 5.83333 10.8333C5.83333 10.3731 6.20643 10 6.66667 10C7.1269 10 7.5 10.3731 7.5 10.8333ZM6.66667 12.5C7.58714 12.5 8.33333 11.7538 8.33333 10.8333C8.33333 9.91286 7.58714 9.16667 6.66667 9.16667C5.74619 9.16667 5 9.91286 5 10.8333C5 11.7538 5.74619 12.5 6.66667 12.5Z"
          fill={fill}
        />
      ),
      viewbox: "0 0 20 20"
    },
    {
      name: "store",
      path: (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.86151 0.833313H17.1385L19.9995 5.60163L20 5.83145C20.0017 6.58124 19.75 7.30962 19.2858 7.89844C18.8216 8.48727 18.1721 8.90201 17.4426 9.07539C16.7132 9.24879 15.9465 9.17066 15.267 8.85368C14.9658 8.71317 14.6895 8.52937 14.446 8.30988C14.2986 8.4433 14.1389 8.56374 13.9685 8.6694C13.444 8.99457 12.8392 9.16686 12.2221 9.16686C11.605 9.16686 11.0002 8.99457 10.4757 8.6694C10.306 8.56418 10.1469 8.44431 10 8.31156C9.85311 8.44431 9.69401 8.56418 9.52431 8.6694C8.99984 8.99457 8.39501 9.16686 7.77792 9.16686C7.16083 9.16686 6.556 8.99457 6.03154 8.6694C5.86112 8.56374 5.70139 8.4433 5.55398 8.30989C5.31049 8.52937 5.03423 8.71317 4.73301 8.85368C4.05351 9.17066 3.28685 9.24879 2.55738 9.07539C1.8279 8.90201 1.1784 8.48727 0.714198 7.89844C0.249997 7.30962 -0.00167111 6.58124 8.35143e-06 5.83145L0.000523137 5.60163L2.86151 0.833313ZM3.80516 2.49998L1.67928 6.04313C1.71639 6.34255 1.83464 6.62761 2.02305 6.86661C2.25468 7.16043 2.57879 7.36738 2.94279 7.4539C3.3068 7.54042 3.68936 7.50144 4.02843 7.34327C4.3675 7.1851 4.64319 6.91702 4.81079 6.58251L5.55928 5.08865L6.30226 6.58527C6.43866 6.86003 6.64907 7.09126 6.90978 7.2529C7.1705 7.41455 7.47116 7.50019 7.77792 7.50019C8.08468 7.50019 8.38535 7.41455 8.64606 7.2529C8.90678 7.09126 9.11719 6.86003 9.25359 6.58527L10 5.08171L10.7464 6.58527C10.8828 6.86003 11.0932 7.09126 11.3539 7.2529C11.6147 7.41455 11.9153 7.50019 12.2221 7.50019C12.5288 7.50019 12.8295 7.41455 13.0902 7.2529C13.3509 7.09126 13.5614 6.86003 13.6978 6.58527L14.4407 5.08865L15.1892 6.58251C15.3568 6.91702 15.6325 7.1851 15.9716 7.34327C16.3107 7.50144 16.6932 7.54042 17.0572 7.4539C17.4212 7.36738 17.7453 7.16043 17.977 6.86661C18.1654 6.62761 18.2836 6.34255 18.3207 6.04313L16.1948 2.49998H3.80516ZM4.16667 9.99998V17.5H7.5V12.5H12.5V17.5H15.8333V9.99998H17.5V19.1666H2.5V9.99998H4.16667ZM10.8333 17.5V14.1666H9.16667V17.5H10.8333Z"
          fill={fill}
        />
      ),
      viewbox: "0 0 20 20"
    },
    {
      name: "exit",
      path: (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.5 0.5H0.5V5.19697H2.16667V2.16667H13.8333V13.8333H2.16667V10.803H0.5V15.5H15.5V0.5ZM6.78787 4.39725L10.3906 8L6.78787 11.6028L5.60935 10.4242L7.20026 8.83333H1.33333V7.16667H7.20026L5.60935 5.57576L6.78787 4.39725Z"
          fill={fill}
        />
      ),
      viewbox: "0 0 16 16"
    },
    {
      name: "house",
      path: (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 0.589966L19.6944 8.52172L18.639 9.81165L10 2.7434L1.36103 9.81165L0.305634 8.52172L10 0.589966ZM7.50005 13.3334H12.5V18.3334H15.8334V10.0001H17.5V20.0001H2.50005V10.0001H4.16671V18.3334H7.50005V13.3334ZM9.16671 18.3334H10.8334V15.0001H9.16671V18.3334Z"
          fill={fill}
        />
      ),
      viewbox: "0 0 20 20"
    },
    {
      name: "people",
      path: (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.00002 1.33002C5.85075 1.33002 4.74855 1.78656 3.93589 2.59922C3.12323 3.41188 2.66669 4.51408 2.66669 5.66335V7.33002L2.66669 7.3322C2.66835 8.09054 2.86967 8.83506 3.25041 9.49089C3.52945 9.97154 3.89765 10.3921 4.33335 10.7311V10.8176L1.31985 12.0256C0.979936 12.1615 0.68785 12.3964 0.482439 12.6994C0.276896 13.0027 0.166919 13.3605 0.166687 13.7269V17.4967H6.00002V15.4967H2.16669V13.8408L5.18018 12.6328C5.51973 12.4971 5.81111 12.2629 6.01657 11.9605C6.22207 11.6579 6.33239 11.3009 6.33335 10.9352L6.33335 10.9325V9.62176L5.83109 9.33352C5.47798 9.13088 5.18447 8.83883 4.98006 8.48674C4.77582 8.13494 4.66775 7.7356 4.66669 7.32883V5.66335C4.66669 5.04451 4.91252 4.45102 5.3501 4.01343C5.78769 3.57585 6.38118 3.33002 7.00002 3.33002V1.33002ZM2.06185 13.8828L2.06293 13.8824L2.06185 13.8828ZM7.00002 1.33337C8.14929 1.33337 9.25149 1.78992 10.0641 2.60258C10.8768 3.41524 11.3334 4.51744 11.3334 5.66671V7.33337L11.3334 7.33556C11.3317 8.09389 11.1304 8.83842 10.7496 9.49425C10.4706 9.9749 10.1024 10.3955 9.66669 10.7345V10.8209L12.6802 12.0289C13.0201 12.1649 13.3122 12.3997 13.5176 12.7028C13.7231 13.006 13.8331 13.3639 13.8334 13.7302V17.5H6.00002V15.5H11.8334V13.8442L8.81986 12.6362C8.48031 12.5005 8.18893 12.2663 7.98347 11.9638C7.77797 11.6613 7.66765 11.3042 7.66669 10.9385L7.66669 10.9359V9.62511L8.16895 9.33688C8.52206 9.13424 8.81557 8.84219 9.01998 8.4901C9.22422 8.1383 9.33229 7.73896 9.33335 7.33218V5.66671C9.33335 5.04787 9.08752 4.45438 8.64994 4.01679C8.21235 3.57921 7.61886 3.33337 7.00002 3.33337V1.33337ZM11.9382 13.8862L11.9371 13.8857L11.9382 13.8862ZM11.1667 1.07982C11.8255 0.699453 12.5729 0.499225 13.3336 0.499268C14.0943 0.49931 14.8417 0.699623 15.5004 1.08007C16.1592 1.46051 16.7062 2.00768 17.0865 2.66657C17.4667 3.32539 17.6668 4.07269 17.6667 4.83335V6.50002L17.6667 6.5022C17.665 7.26054 17.4637 8.00507 17.083 8.66089C16.8039 9.14154 16.4357 9.56212 16 9.9011V9.98757L19.0135 11.1955C19.3534 11.3315 19.6455 11.5664 19.8509 11.8694C20.0565 12.1727 20.1665 12.5305 20.1667 12.8969V17.5H14.8334V15.5H18.1667V13.0108L15.1532 11.8028C14.8137 11.6671 14.5223 11.4329 14.3168 11.1305C14.1113 10.8279 14.001 10.4709 14 10.1052L14 10.1025V8.79176L14.5023 8.50352C14.8554 8.30088 15.1489 8.00883 15.3533 7.65674C15.5575 7.30494 15.6656 6.9056 15.6667 6.49883V4.83335C15.6668 4.42372 15.559 4.02106 15.3543 3.66627C15.1495 3.31149 14.855 3.01686 14.5002 2.81201C14.1455 2.60715 13.7431 2.49929 13.3335 2.49927C12.9239 2.49924 12.5214 2.60706 12.1667 2.81188L11.3007 3.31188L10.3007 1.57982L11.1667 1.07982Z"
          fill={fill}
        />
      ),
      viewbox: "0 0 20 18"
    },
    {
      name: "link-default",
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.1795 1.12588C12.1799 1.12599 12.1802 1.1261 11.9189 1.91009L12.1795 1.12588L12.9708 1.38962L12.4437 2.97076L11.6564 2.70833L11.6455 2.70494C11.6342 2.70148 11.6143 2.69561 11.5867 2.68808C11.5314 2.67301 11.446 2.65153 11.3366 2.62965C11.1161 2.58555 10.8076 2.54167 10.4583 2.54167C9.75345 2.54167 8.96119 2.71732 8.33925 3.33926L3.33926 8.33925C2.71732 8.96119 2.54167 9.75345 2.54167 10.4583C2.54167 10.8076 2.58555 11.1161 2.62965 11.3366C2.65153 11.446 2.67301 11.5314 2.68808 11.5867C2.69561 11.6143 2.70148 11.6342 2.70494 11.6455L2.70815 11.6559L2.97076 12.4437L1.38962 12.9708L1.1261 12.1802L1.91667 11.9167C1.1261 12.1802 1.12621 12.1805 1.1261 12.1802L1.12565 12.1788L1.12512 12.1772L1.12385 12.1734L1.12044 12.1628C1.11781 12.1546 1.11445 12.1439 1.11049 12.1308C1.10256 12.1048 1.09216 12.0693 1.08014 12.0253C1.05616 11.9373 1.02555 11.8144 0.995349 11.6634C0.935281 11.3631 0.875 10.9424 0.875 10.4583C0.875 9.49655 1.11601 8.20548 2.16074 7.16074L7.16074 2.16074C8.20548 1.11601 9.49655 0.875 10.4583 0.875C10.9424 0.875 11.3631 0.935281 11.6634 0.995349C11.8144 1.02555 11.9373 1.05616 12.0253 1.08014C12.0693 1.09216 12.1048 1.10256 12.1308 1.11049C12.1439 1.11445 12.1546 1.11781 12.1628 1.12044L12.1734 1.12385L12.1772 1.12512L12.1795 1.12588Z"
            fill={fill}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.6104 5.02924L16.8739 5.81981L16.0833 6.08333C16.8739 5.81981 16.874 5.82012 16.8741 5.82045L16.8743 5.82116L16.8749 5.82275L16.8761 5.82663L16.8796 5.83718C16.8822 5.84544 16.8855 5.85614 16.8895 5.86918C16.8974 5.89524 16.9078 5.9307 16.9198 5.97474C16.9438 6.06269 16.9744 6.18557 17.0046 6.33656C17.0647 6.63691 17.125 7.05757 17.125 7.54166C17.125 8.50345 16.884 9.79452 15.8392 10.8393L10.8393 15.8392C9.79452 16.884 8.50345 17.125 7.54166 17.125C7.05757 17.125 6.63691 17.0647 6.33656 17.0046C6.18557 16.9744 6.06269 16.9438 5.97474 16.9198C5.9307 16.9078 5.89524 16.8974 5.86918 16.8895C5.85614 16.8855 5.84544 16.8822 5.83718 16.8796L5.82663 16.8761L5.82275 16.8749L5.82116 16.8743L5.82045 16.8741C5.82012 16.874 5.81981 16.8739 6.08333 16.0833L5.81981 16.8739L5.02924 16.6104L5.55628 15.0292L6.34366 15.2917C6.34318 15.2915 6.34327 15.2916 6.34392 15.2918L6.34411 15.2918L6.35445 15.2951C6.36582 15.2985 6.38569 15.3044 6.41327 15.3119C6.46855 15.327 6.55401 15.3485 6.66343 15.3703C6.88392 15.4144 7.19242 15.4583 7.54166 15.4583C8.24654 15.4583 9.03881 15.2827 9.66074 14.6607L14.6607 9.66074C15.2827 9.03881 15.4583 8.24654 15.4583 7.54166C15.4583 7.19242 15.4144 6.88392 15.3703 6.66343C15.3485 6.55401 15.327 6.46855 15.3119 6.41327C15.3044 6.38569 15.2985 6.36582 15.2951 6.35445L15.2918 6.34411L15.2918 6.34392C15.2916 6.34327 15.2915 6.34318 15.2917 6.34366L15.0292 5.55628L16.6104 5.02924Z"
            fill={fill}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.67851 11.5L1.5 17.6785L0.321487 16.5L6.5 10.3215L7.67851 11.5Z"
            fill={fill}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.6785 1.49998L11.5 7.6785L10.3215 6.49998L16.5 0.321472L17.6785 1.49998Z"
            fill={fill}
          />
        </>
      ),
      viewbox: "0 0 18 18"
    },
    {
      name: "square-pin",
      path: (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.58328 1.66667C7.28573 1.66667 4.87495 3.41363 4.87495 6.40152C4.87495 7.06221 5.14993 7.91514 5.64844 8.88365C6.13798 9.83474 6.80016 10.8162 7.47719 11.7117C8.15205 12.6044 8.82892 13.395 9.33803 13.9631C9.42509 14.0603 9.50713 14.1508 9.58328 14.2341C9.65943 14.1508 9.74147 14.0603 9.82853 13.9631C10.3376 13.395 11.0145 12.6044 11.6894 11.7117C12.3664 10.8162 13.0286 9.83474 13.5181 8.88365C14.0166 7.91514 14.2916 7.06221 14.2916 6.40152C14.2916 3.41363 11.8808 1.66667 9.58328 1.66667ZM8.99009 16.0351C8.99022 16.0352 8.99032 16.0353 9.58328 15.4498L8.99009 16.0351ZM9.58328 15.4498L10.1762 16.0353L9.58328 16.6358L8.99009 16.0351L8.98489 16.0298L8.97156 16.0162L8.92221 15.9655C8.87956 15.9214 8.81786 15.8572 8.73982 15.7747C8.58378 15.6097 8.36215 15.3715 8.09676 15.0754C7.56681 14.4839 6.85827 13.6567 6.1477 12.7169C5.43931 11.7798 4.71608 10.714 4.16656 9.6464C3.626 8.5962 3.20828 7.459 3.20828 6.40152C3.20828 2.34167 6.52442 0 9.58328 0C12.6421 0 15.9583 2.34167 15.9583 6.40152C15.9583 7.459 15.5406 8.5962 15 9.6464C14.4505 10.714 13.7272 11.7798 13.0189 12.7169C12.3083 13.6567 11.5998 14.4839 11.0698 15.0754C10.8044 15.3715 10.5828 15.6097 10.4267 15.7747C10.3487 15.8572 10.287 15.9214 10.2444 15.9655L10.195 16.0162L10.1817 16.0298L10.1768 16.0347C10.1767 16.0349 10.1762 16.0353 9.58328 15.4498ZM3.29559 13.1893L4.78772 13.9319L3.01215 17.5H16.1545L14.3789 13.9319L15.8711 13.1893L18.8455 19.1667H0.321167L3.29559 13.1893ZM8.83328 6.4015C8.83328 5.97934 9.17281 5.64392 9.58328 5.64392C9.99375 5.64392 10.3333 5.97934 10.3333 6.4015C10.3333 6.82365 9.99375 7.15907 9.58328 7.15907C9.17281 7.15907 8.83328 6.82365 8.83328 6.4015ZM9.58328 3.97725C8.24485 3.97725 7.16661 5.06638 7.16661 6.4015C7.16661 7.73661 8.24485 8.82574 9.58328 8.82574C10.9217 8.82574 11.9999 7.73661 11.9999 6.4015C11.9999 5.06638 10.9217 3.97725 9.58328 3.97725Z"
          fill={fill}
        />
      ),
      viewbox: "0 0 19 20"
    },
    {
      name: "info",
      path: (
        <>
          <path fillRule="evenodd" clipRule="evenodd" d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z" fill={fill} />
          <path fillRule="evenodd" clipRule="evenodd" d="M13 10.0909V17.5455H11V10.0909H13Z" fill={fill} />
          <path d="M12 8.36364C12.5021 8.36364 12.9091 7.95662 12.9091 7.45455C12.9091 6.95247 12.5021 6.54545 12 6.54545C11.4979 6.54545 11.0909 6.95247 11.0909 7.45455C11.0909 7.95662 11.4979 8.36364 12 8.36364Z" fill={fill} />
        </>
      )
    },
    {
      name: "arrow-back",
      path: (
        <>
          <path fillRule="evenodd" clipRule="evenodd" d="M2.99991 11H21.9999V13H2.99991V11Z" fill={fill} />
          <path fillRule="evenodd" clipRule="evenodd" d="M7.99991 18.4142L1.58569 12L7.99991 5.58582L9.41412 7.00003L4.41412 12L9.41412 17L7.99991 18.4142Z" fill={fill} />
        </>
      ),
      viewbox: "0 0 24 24"
    },
    {
      name: "person-add",
      path: (
        <>
          <path fillRule="evenodd" clipRule="evenodd" d="M7.53724 12.1915C6.33295 12.4131 5.28414 12.7128 4.46503 12.9889C2.95361 13.5002 1.95239 14.9219 1.95239 16.5051V21.0952H12L11.9992 19.0952H3.95239V16.5051C3.95239 15.767 4.41761 15.1165 5.10451 14.884C6.52999 14.4033 8.68392 13.8571 11.0953 13.8571C12.7508 13.8571 14.1438 12.8926 15.081 11.6964C16.0213 10.4963 16.619 8.92632 16.619 7.42857V6.52381C16.619 3.47348 14.1456 1 11.0952 1C8.04489 1 5.57141 3.47348 5.57141 6.52381V7.42857C5.57141 8.92632 6.16913 10.4963 7.10939 11.6964C7.24294 11.8668 7.38574 12.0326 7.53724 12.1915ZM7.57141 6.52381C7.57141 4.57805 9.14946 3 11.0952 3C13.041 3 14.619 4.57805 14.619 6.52381V7.42857C14.619 8.42887 14.2039 9.57313 13.5067 10.4629C12.8066 11.3564 11.9378 11.8571 11.0953 11.8571C10.2527 11.8571 9.38384 11.3564 8.6837 10.4629C7.98657 9.57313 7.57141 8.42887 7.57141 7.42857V6.52381Z" fill={fill} />
          <path d="M19 14V17H22V19H19V22H17V19H14V17H17V14H19Z" fill={fill} />
        </>
      )
    },
    {
      name: 'person-delete',
      path: (
        <>
          <path fillRule="evenodd" clipRule="evenodd" d="M10.0496 16.2553C8.44393 16.5508 7.04551 16.9504 5.95337 17.3185C3.93814 18.0003 2.60318 19.8959 2.60318 22.0068V28.1269H16L15.9989 25.4603H5.26985V22.0068C5.26985 21.0227 5.89014 20.1553 6.80601 19.8453C8.70665 19.2044 11.5786 18.4761 14.7937 18.4761C17.0011 18.4761 18.8584 17.1901 20.108 15.5952C21.3617 13.9951 22.1587 11.9018 22.1587 9.90476V8.69841C22.1587 4.63131 18.8608 1.33333 14.7936 1.33333C10.7265 1.33333 7.42854 4.63131 7.42854 8.69841V9.90476C7.42854 11.9018 8.2255 13.9951 9.47918 15.5952C9.65725 15.8224 9.84765 16.0435 10.0496 16.2553ZM10.0952 8.69841C10.0952 6.10407 12.1993 4 14.7936 4C17.388 4 19.492 6.10407 19.492 8.69841V9.90476C19.492 11.2385 18.9385 12.7642 18.0089 13.9505C17.0755 15.1419 15.9171 15.8095 14.7937 15.8095C13.6703 15.8095 12.5118 15.1419 11.5783 13.9505C10.6488 12.7642 10.0952 11.2385 10.0952 9.90476V8.69841Z" fill={fill} />
          <path d="M25.5047 23.6191L29.1237 20L27.2381 18.1144L23.6191 21.7335L20 18.1144L18.1144 20L21.7335 23.6191L18.1144 27.2381L20 29.1237L23.6191 25.5047L27.2381 29.1237L29.1237 27.2381L25.5047 23.6191Z" fill={fill} />
        </>
      ),
      viewBox: "0 0 32 32"
    },
    {
      name: 'contract',
      path: (
        <>
          <path fillRule="evenodd" clipRule="evenodd" d="M13 17.8917V20H11V17.9735C9.84583 17.8865 8.66592 17.602 7.66174 17.241L6.7207 16.9027L7.3973 15.0207L8.33834 15.359C9.18752 15.6642 10.1255 15.8849 11 15.9665V12.4564C10.3504 12.2259 9.6488 11.935 9.06985 11.5105C8.24695 10.9071 7.64804 10.0177 7.64804 8.732C7.64804 7.63612 8.12811 6.79887 8.895 6.25824C9.51381 5.822 10.2692 5.61148 11 5.52457V4H13V5.53708C14.1221 5.66544 15.1854 5.97368 15.8567 6.34266L16.7331 6.82435L15.7697 8.57704L14.8933 8.09534C14.5117 7.88558 13.7992 7.66715 13 7.55308V11.022C13.5678 11.2215 14.1633 11.4609 14.6606 11.7814C15.4704 12.3032 16.132 13.1117 16.132 14.351C16.132 15.3986 15.7814 16.2674 15.115 16.8974C14.5244 17.4559 13.7654 17.7516 13 17.8917ZM13 15.8389C13.3301 15.7401 13.5734 15.6026 13.741 15.4441C13.9559 15.2409 14.132 14.9244 14.132 14.351C14.132 13.9693 13.9832 13.7241 13.5772 13.4626C13.4085 13.3539 13.2162 13.2566 13 13.1635V15.8389ZM11 10.3104V7.54497C10.5856 7.61716 10.2651 7.7394 10.0474 7.89289C9.80622 8.06288 9.64804 8.29339 9.64804 8.732C9.64804 9.28335 9.85963 9.60954 10.2525 9.89759C10.4617 10.051 10.7114 10.1844 11 10.3104Z" fill={fill} />
          <path fillRule="evenodd" clipRule="evenodd" d="M2 1H22V23H2V1ZM4 3V21H20V3H4Z" fill={fill} />
        </>
      ),
      viewBox: "0 0 24 24"
    },
    {
      name: 'chevron-right',
      path: (
        <>
          <path fillRule="evenodd" clipRule="evenodd" d="M10.4142 7L15.8284 12.4142L10.4142 17.8284L9 16.4142L13 12.4142L9 8.41421L10.4142 7Z" fill={fill} />
        </>
      ),
      viewBox: "0 0 24 24"
    },
    {
      name: 'chevron-down',
      path: (
        <>
          <path fillRule="evenodd" clipRule="evenodd" d="M8.00003 9L12 13L16 9L17.4142 10.4142L12 15.8284L6.58582 10.4142L8.00003 9Z" fill={fill} />
        </>
      ),
      viewBox: "0 0 24 24"
    },
    {
      name: 'line',
      path: (
        <>
          <path fillRule="evenodd" clipRule="evenodd" d="M7 11H17V13H7V11Z" fill={fill} />
        </>
      ),
      viewBox:"0 0 24 24"
    },
    {
      name:'notification-outlined',
      path:(
        <>
          <path fillRule="evenodd" clipRule="evenodd" d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z" fill={fill} />
        </>
      ),
      viewBox: "0 0 24 24"

    },
    {
      name: 'notification',
      path: (
        <>
          <path fillRule="evenodd" clipRule="evenodd" d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" fill={fill} />
        </>
      ),
      viewBox: "0 0 24 24"

    },
    {
      name: 'inbox',
      path: (
        <>
          <path fillRule="evenodd" clipRule="evenodd" d="M19 3H4.99c-1.11 0-1.98.89-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10z" fill={fill} />
        </>
      ),
      viewBox: "0 0 24 24"

    },
    {
      name: 'comment',
      path: (
        <>
          <path fillRule="evenodd" clipRule="evenodd" d="M0 1H24V18H16.4806L12 23.6008L7.51938 18H0V1ZM2 3V16H8.48063L12 20.3992L15.5194 16H22V3H2Z" fill={fill} />
          <path fillRule="evenodd" clipRule="evenodd" d="M6 6H18V8H6V6Z" fill={fill} />
          <path fillRule="evenodd" clipRule="evenodd" d="M6 11H14V13H6V11Z" fill={fill} />
        </>
      ),
    },
    {
      name: 'delete',
      path: (
        <>
          <path fillRule="evenodd" clipRule="evenodd" d="M3 7.27272V5.27272H7.72729V3.81818C7.72729 3.33597 7.91885 2.87351 8.25983 2.53253C8.6008 2.19156 9.06326 2 9.54548 2H14.4546C14.9368 2 15.3992 2.19156 15.7402 2.53253C16.0812 2.87351 16.2727 3.33597 16.2727 3.81818V5.27272H21V7.27272H3ZM9.72729 4V5.27272H14.2727V4H9.72729Z" fill={fill}/>
          <path d="M17.7978 9H19.8022L19.1222 19.1996C19.0172 20.7754 17.7083 22 16.1289 22H7.87108C6.29169 22 4.98278 20.7755 4.87772 19.1996L4.19775 9H6.20219L6.87329 19.0665C6.90831 19.5918 7.34462 20 7.87108 20H16.1289C16.6553 20 17.0916 19.5918 17.1267 19.0665L17.7978 9Z" fill={fill}/>
        </>
      ),
      viewbox: "0 0 24 24"
    },
    {
      name: 'camera',
      path: (
        <>
          <path fillRule="evenodd" clipRule="evenodd" d="M12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9ZM6 13C6 9.68629 8.68629 7 12 7C15.3137 7 18 9.68629 18 13C18 16.3137 15.3137 19 12 19C8.68629 19 6 16.3137 6 13Z" fill={fill}/>
          <path fillRule="evenodd" clipRule="evenodd" d="M8.46482 1H15.5352L17.5352 4H21C21.7957 4 22.5587 4.31607 23.1213 4.87868C23.6839 5.44129 24 6.20435 24 7V20C24 20.7957 23.6839 21.5587 23.1213 22.1213C22.5587 22.6839 21.7957 23 21 23H3C2.20435 23 1.44129 22.6839 0.87868 22.1213C0.316071 21.5587 0 20.7957 0 20V7C0 6.20435 0.316071 5.44129 0.87868 4.87868C1.44129 4.31607 2.20435 4 3 4H6.46482L8.46482 1ZM9.53518 3L7.53518 6H3C2.73478 6 2.48043 6.10536 2.29289 6.29289C2.10536 6.48043 2 6.73478 2 7V20C2 20.2652 2.10536 20.5196 2.29289 20.7071C2.48043 20.8946 2.73478 21 3 21H21C21.2652 21 21.5196 20.8946 21.7071 20.7071C21.8946 20.5196 22 20.2652 22 20V7C22 6.73478 21.8946 6.48043 21.7071 6.29289C21.5196 6.10536 21.2652 6 21 6H16.4648L14.4648 3H9.53518Z" fill={fill}/>
          <path d="M4 9C4.55228 9 5 8.55228 5 8C5 7.44772 4.55228 7 4 7C3.44772 7 3 7.44772 3 8C3 8.55228 3.44772 9 4 9Z" fill={fill}/>
        </>
      ),
      viewbox: "0 0 24 24"
    },
    {
      name: 'download',
      path: (
        <>
         <path fillRule="evenodd" clipRule="evenodd" d="M11 17V1H13V17H11Z" fill={fill}/>
         <path fillRule="evenodd" clipRule="evenodd" d="M6 9.58579L12 15.5858L18 9.58579L19.4142 11L12 18.4142L4.58579 11L6 9.58579Z" fill={fill}/>
         <path fillRule="evenodd" clipRule="evenodd" d="M1 21H23V23H1V21Z" fill={fill}/>
        </>
      ),
      viewbox: "0 0 24 24"
    },

  ];
  let selectedIcon =
    icons.filter(icon => {
      return icon.name === name;
    })[0] || FallBackIcon(fill);

  return [selectedIcon.path, selectedIcon.viewbox];
};

const Icon = ({ size = "32px", fill, name, style, className, onClick }) => {
  const [Path, viewbox] = getIcon(fill, name);
  if (name === 'picto' && config.CLIENT === 'agx') return null
  return (
    <svg
      width={size}
      height={size}
      viewBox={viewbox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ margin: "0 2px", ...style }}
      className={className}
      onClick={onClick}
    >
      {Path ? Path : null}
    </svg>
  );
};

export default Icon;